export * from "./Error404Page"
export { default } from "./Error404Page"
